import { render } from "./AddInformationTableType.vue?vue&type=template&id=63b5f458"
import script from "./AddInformationTableType.vue?vue&type=script&lang=js"
export * from "./AddInformationTableType.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__